import React from "react";

function UserPlusIcon({ fill, ...restProps }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M7.817 1.705a4.7 4.7 0 0 0-1.736.567A4.56 4.56 0 0 0 3.767 6.25c0 1.651.875 3.155 2.314 3.978a4.58 4.58 0 0 0 4.505 0c2.083-1.191 2.902-3.776 1.878-5.925a4.56 4.56 0 0 0-4.647-2.598m1.316 1.728c.796.227 1.526.86 1.872 1.622.317.701.317 1.69-.001 2.392-.35.772-1.11 1.416-1.937 1.641-.343.094-1.165.085-1.515-.015a3.06 3.06 0 0 1-1.889-1.626c-.319-.702-.319-1.691-.001-2.392a3.01 3.01 0 0 1 2.166-1.69c.277-.051 1.026-.012 1.305.068m6.469 8.271a.9.9 0 0 0-.565.579c-.022.082-.037.47-.037 1.007v.873l-.942.01c-1.047.011-1.069.016-1.302.249a.72.72 0 0 0-.237.578c0 .252.062.403.237.578.233.233.255.238 1.3.249l.94.01.01.94c.012 1.046.016 1.067.25 1.301a.71.71 0 0 0 .577.237.72.72 0 0 0 .578-.237c.234-.234.238-.255.249-1.301l.01-.94.94-.01c1.046-.011 1.068-.016 1.301-.249a.72.72 0 0 0 .237-.578.72.72 0 0 0-.237-.578c-.233-.233-.255-.238-1.301-.249l-.94-.01-.01-.94c-.009-.828-.017-.954-.071-1.061a1.04 1.04 0 0 0-.411-.412 1 1 0 0 0-.576-.046m-11.14.434c-1.255.145-2.41.912-3.065 2.035a4.5 4.5 0 0 0-.445 1.134c-.077.378-.126 1.17-.113 1.83.012.646.033.724.25.941a.72.72 0 0 0 .578.237.71.71 0 0 0 .577-.237c.229-.229.235-.258.26-1.311.025-1.043.044-1.165.244-1.59a2.46 2.46 0 0 1 1.793-1.38c.14-.026 1.123-.045 2.976-.059l2.766-.021.136-.089a.8.8 0 0 0 .364-.469c.063-.213.063-.271 0-.485a.8.8 0 0 0-.364-.469l-.136-.088-2.783-.005c-1.531-.002-2.898.009-3.038.026"
        fillRule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default UserPlusIcon;
